import { render, staticRenderFns } from "./RewardOverlay.vue?vue&type=template&id=03fd6ba6&scoped=true"
import script from "./RewardOverlay.vue?vue&type=script&lang=js"
export * from "./RewardOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fd6ba6",
  null
  
)

export default component.exports